import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoaderProps {
  HasContainer?: boolean;
  IsLoading: boolean;
  Small?: boolean;
}

const Loader = ({
  HasContainer = true,
  IsLoading,
  Small = false,
}: LoaderProps) => {
  if (!IsLoading) {
    return null;
  }

  if (!HasContainer) {
    return <Spinner className="spinner-lg" variant="primary" />;
  }

  if (Small) {
    return <Spinner className="spinner-sm" variant="primary" />;
  }

  return (
    <div className="m-32 text-center">
      <Spinner className="spinner-lg" variant="primary" />
    </div>
  );
};

// Loader.defaultProps = {
//   HasContainer: true,
// };

export default Loader;
export { Loader };
export type { LoaderProps };
